<br>
<div class="container-fluid ">
    <div class="user-profile">
      <div class="row">
        <!-- user profile first-style start-->
        <div class="col-6" style="text-align: start;">
          <h5 class="pb-2">تفاصيل الموردين</h5>
      </div>
        <div class="col-sm-12">
          <div class="card hovercard text-center">
            <div class="user-image">
              <div class="avatar">
                <!-- <img alt="Risk Logo" src="../../../../assets/Risk Logo 200 x 200/Risk-Logo-200-x-200.png"> -->
                <img alt="Risk Logo" src="../../../../assets/Risk Logo 200 x 200/Ekram Logo 200 x 200.png">
                <!-- <img alt="Risk Logo" src="../../../../assets/Risk Logo 200 x 200/Risk-Logo-200-x-200-02.png"> -->
  
              </div>
              <!-- <div class="icon-wrapper"><i class="icofont icofont-pencil-alt-5"><input class="upload" type="file"
                     /></i></div> -->
            </div>
            <div class="info">
              <div class="row d-flex justify-content-center">
                  <div class="col-lg-4 col-md-6 ">    
                    <div >
                      <h6>
                        الاسم :  {{SupplierDetails?.name}}
                      </h6>
  
  
                    </div>
  
                   
                </div>
                <div class="col-lg-4 col-md-6 mb-3">
                  <div  >
                    <h6> نوع التسجيل : {{SupplierDetails?.supplierRegisterationTypeTitle}}
                    </h6>
        
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-3">
                  <div  >
                    <h6> نوع تسجيل اخر : {{SupplierDetails?.otherRegisterationType}}
                    </h6>
        
                  </div>
                </div>
              </div>
              <div class="row d-flex justify-content-center mt-5">
                <div class="col-lg-4 col-md-6 mb-3">
                  <div  >
                    <h6> النوع : {{SupplierDetails?.supplierTypeTitle}}
                    </h6>
        
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 mb-3">
                  <div  >
                    <h6> نوع اخر : {{SupplierDetails?.otherSupplierType}}
                    </h6>
        
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-3">
                  <div  >
                    <h6> تصنيف الاعمال : {{SupplierDetails?.businessType}}
                    </h6>
        
                  </div>
                </div>
            </div>
            <div class="row d-flex justify-content-center mt-5">
                <div class="col-lg-4 col-md-6">
                  <div >
                    <h6 class="responsive-font-example">اسم المسؤول عن التواصل : {{SupplierDetails?.contactPersonName}}</h6>
  
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-3">
                  <div  >
                    <h6> رقم التسجيل الضريبي : {{SupplierDetails?.taxRegisterationNo}}
                    </h6>
        
                  </div>
            </div>
      
            <div class="col-lg-4 col-md-6 mb-3">
              <div  >
                <h6> رقم السجل التجاري : {{SupplierDetails?.taxRegisterationNo}}
                </h6>

              </div>
            </div>
            </div>
              <div class="row d-flex justify-content-center mt-5">
                <div class="col-lg-4 col-md-6">
                  <div>
                    <h6>المحافظه: {{SupplierDetails?.governorateTitle}}</h6>
  
                  </div>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div >
                    <h6 class="responsive-font-example">المدينه : {{SupplierDetails?.cityTitle}}</h6>
                  </div>
                </div>
                 <div  class="col-lg-4 col-md-6">
                  <div >
                     <h6> رقم الهاتف :{{SupplierDetails?.phoneNumber}} </h6>
                    
                    <br>
                  </div>
                </div>
              
              </div>
              <div class="row text-center mt-5">
               
                <div class="col-lg-4 col-md-6 mb-3 mt-2">
                  <div >
                    <h6 class="responsive-font-example m-0">نوع المورد :{{SupplierDetails?.supplierTypeTitle}}</h6>
        
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-3 mt-2">
                  <div  >
                    <h6> الوصف :
                       {{SupplierDetails?.description}}
                    </h6>
        
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>

  <div class="row">
    <!-- user profile first-style start-->

    <div class="col-sm-12">
        <div class="card hovercard text-center">                                                                                                                                        
            <div class="info">
                <div class="row">
                    <div class="col-sm-12">
                      <div class="card">
                        
                         <div class="row"  style=" padding: 30px;">
                          <div   style="width: 2%;" class="col-4 text-center  mt-3">
                            <label style="color: #4da3ba;
                            font-weight: bolder;"> البطاقة الضريبية</label>
                            <div class="image-area text-center bg-white" style="margin: 8px;"  >
                              <img  class="imgDiv" *ngIf="taxCardEx!='pdf'"  [src]="taxCard"  height="200" width="200"  (click)="OpenImage(taxCard)">
                              <img   class="imgDiv" *ngIf="taxCardEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(taxCard)">

                              <br>
                              <!-- <p style="font-size: medium;">
                                {{item.title}}</p>
           -->
                            </div>
                           </div>
                           <div   style="width: 2%;" class="col-4 text-center  mt-3">
                            <label style="color: #4da3ba;
                            font-weight: bolder;"> شهادة تسجيل القيمة المضافة</label>
                            <div class="image-area text-center bg-white" style="margin: 8px;"  >
                              <img  class="imgDiv" *ngIf="vatRegisterationCertificateEx!='pdf'"  [src]="vatRegisterationCertificate"  height="200" width="200"  (click)="OpenImage(vatRegisterationCertificate)">
                              <img  class="imgDiv" *ngIf="vatRegisterationCertificateEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(vatRegisterationCertificate)">

                              <br>
                              <!-- <p style="font-size: medium;">
                                {{item.title}}</p> -->
          
                            </div>
                           </div>
                           <div   style="width: 2%;" class="col-4 text-center  mt-3">
                            <label style="color: #4da3ba;
                            font-weight: bolder;"> السجل التجاري</label>
                            <div class="image-area text-center bg-white" style="margin: 8px;"  >
                              <img class="imgDiv" *ngIf="commercialRegisterationEx!='pdf'"   [src]="commercialRegisteration"  height="200" width="200"  (click)="OpenImage(commercialRegisteration)">
                              <img class="imgDiv"  *ngIf="commercialRegisterationEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(commercialRegisteration)">

                              <br>

                            </div>
                           </div>
          
                           <div   style="width: 2%;" class="col-4 text-center  mt-3">
                            <label style="color: #4da3ba;
                            font-weight: bolder;"> البطاقة الالكترونية</label>
                              <div class="image-area text-center bg-white" style="margin: 8px;"  >
                                <img class="imgDiv" *ngIf="electronicCardEx!='pdf'"    [src]="electronicCard"  height="200" width="200"  (click)="OpenImage(electronicCard)">
                                <img class="imgDiv"  *ngIf="electronicCardEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(electronicCard)">

                              </div>
                             </div>
          
                          
          
                          
                         </div>
            
          </div>
                  </div>
                  </div>
           
          </div>
    </div>
  </div>